import { render, staticRenderFns } from "./AddSchool.vue?vue&type=template&id=5700afac"
import script from "./AddSchool.vue?vue&type=script&lang=js"
export * from "./AddSchool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports